<div class="action-item-rows">
   <ng-container *ngFor="let item of metricsToDisplay">
      <action-item-expandable-row
         *ngIf="item.task.active"
         [taskId]="item.task.id"
         [title]="item.task.name"
         [units]="item.task.units"
         [barColor]="'#e4e4e4'"
         [vetcorAvg]=""
         [current]="item.metric?.startValue"
         [target]="item.metric?.targetValue"
         [kpis]="item.task.kpis"
         [kpiMap]="kpiMap"
         [editable]="editable"
         [toggleEnabled]="editable && item.metric?.isActive"
         [isPublished]="item.metric?.isPublished">
         <div [innerHTML]="item.task.content"></div>
      </action-item-expandable-row>
   </ng-container>
</div>
